var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{attrs:{"loading":_vm.loading}},[_vm._l((_vm.requiredFileGroups),function(requiredFiles,title){return _c('RequiredFileManager',{key:title,attrs:{"required-files":requiredFiles,"add-title":title}})}),_vm._v(" "),_c('FileManager',{attrs:{"available-file-types":['Belege'],"model-type":{
      id: _vm.contract.number,
      model: 'Contract'
    }}})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }